// extracted by mini-css-extract-plugin
module.exports = {"form":"ManufacturerForm_form__6wkYa"};